<script setup>
import {Link as InertiaLink} from '@inertiajs/vue3';

defineProps({
    href: {
        type: String,
        default: null,
    },
    as: {
        type: String,
        default: null,
    },
    blank: {
        type: Boolean,
        default: false,
    },
});

const cssClasses =
    'block px-4 py-2 text-sm leading-5 text-base-content/70 hover:bg-base-content/10 focus:outline-none focus:bg-base-content/10 transition duration-150 ease-in-out';
</script>

<template>
    <div>
        <button v-if="as === 'button'" type="submit" class="w-full text-start" :class="cssClasses">
            <slot />
        </button>

        <a v-else-if="as === 'anchor'" :href="href" :class="cssClasses" :target="blank ? '_blank' : null">
            <slot />
        </a>

        <InertiaLink v-else :href="href" :class="cssClasses" :target="blank ? '_blank' : null">
            <slot />
        </InertiaLink>
    </div>
</template>
